export class proposalData {
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    email: string = '';
    sumInsured: string = '';
    title : string = '';
    address1 : string = '';
    dob : string = '';
    // adhaar : string = '';
    pincode : string = '';
    cityFirst : string = '';
    stateFirst : string = '';
    city : string = '';
    state : string = '';
    occupation : string = '';
    nomineeName : string = '';
    nomineeRelation : string = '';
    prospectId : string = '';
    quoteId : string = '';

    medicineBranch: string = '';
    qualification: string;
    selectedSpecialization: string;
    retroactiveDate: Date;
    yearOfReg: string;
    avgPatient: string;
    medicalReg: string;
    practiceYear: string;
    member: string;
    AssoName: string;
    AssoConact: string;
    assoAddress: string;
    form: any;
    year: string;

    designation : string;
    annualIncome: string;
    pan: string;
    adhaar: string;
    engineNumber: string;
    vehicleRegNum: string;
    chasisNumber: string;
    manufacturer : string;
    carModel: string;
    area : any;
    manufaturingDate : string;
    subInsurance: string;
    previousInsurer: string;

    constructor() {
    }
}